<p *ngIf="weightError" class="text-center p-2 text-danger">Weight is over 100%!</p>
<div style="margin-top: 3em">
    <table class="table m-0">
        <thead>
        <tr>
            <th class="bold-header">Name</th>
            <th >Weight</th>
            <th class="bold-header">ISIN</th>
            <th class="bold-header">MCap(M$)</th>
            <th class="bold-header">Earliest price data point</th>
            <th class="bold-header">Asset Class</th>
            <th class="bold-header">Currency</th>
            <th class="bold-header">Sector</th>
        </tr>
        </thead>
        <tbody>
        <tr *ngFor="let item of list;index as index" [class.selected-row]="item.markedForDelete" [class.etf-border-top]="list[index-1] && list[index-1].isStock() && item.isFund()">
            <td class=" font-weight-bold">
                <mat-checkbox [checked]="item.markedForDelete" color="primary" (change)="onSelect($event, item)">{{item.fund_reference_table && item.fund_reference_table.name ? item.fund_reference_table.name : item.company_name}}</mat-checkbox>
            </td>
            <td>
                <mat-form-field style="max-width: 100px; margin-top:0.75em;" appearance="outline">
                    <input matInput [(ngModel)]="item.weight" type="number" min="0" max="100" [disabled]="portfolio.weighting_type !== 'manual'" (ngModelChange)="onWeightChange(item)">
                    <span matSuffix>%</span>
                </mat-form-field>
            </td>
            <td>{{item.isin}}</td>
            <td class="text-end">{{item.market_value_usd|number:'1.0-0'}} {{item.fund_reference_table.AverageMarketCapital| number:'1.0-0'}}</td>
            <td>{{item.fund_reference_table.FundInceptionDate ? item.fund_reference_table.FundInceptionDate : item.p_first_date}}</td>
            <td>{{item.security_type_equity}}</td>
            <td>{{item.currency?.code || item.currency?.code || item.currency }} </td>
            <td>{{item.sector && item.sector.name ? item.sector.name : item.fund_reference_table.GlobalCategoryName ? item.fund_reference_table.GlobalCategoryName : item.etf_reference_table.segment_desc}}
            </td>
        </tr>
        </tbody>
    </table>
    <button *ngIf="selected.length" mat-button color="warn" (click)="onRemoveClick()" class="border-primary text-danger rounded-pill">Remove selected</button>
</div>
